import { message } from "antd";
import { api } from "./api";
import {
  ICreateProposalPayload,
  IProposalItemInput,
  ProposalCurrency,
} from "../types/commercialProposal.type";

export const commercialProposalApi = {
  getAll: (params?: Record<string, unknown>) => api.get("/commercial-proposal", { params }),

  getById: (id: string) => api.get(`/commercial-proposal/${id}`),

  getMeta: () => api.get("/commercial-proposal/meta"),

  getProduceOptions: (params?: { search?: string; limit?: number }) =>
    api.get("/commercial-proposal/produce-options", { params }),

  create: (data: ICreateProposalPayload) => api.post("/commercial-proposal", data),

  update: (
    id: string,
    data: {
      clientId?: string;
      currency?: ProposalCurrency;
      items: IProposalItemInput[];
      leadTimeDays?: number;
    }
  ) => api.put(`/commercial-proposal/${id}`, data),

  updateStatus: (id: string, status: string) =>
    api.patch(`/commercial-proposal/${id}/status`, { status }),

  delete: (id: string) => api.delete(`/commercial-proposal/${id}`),

  getHtml: (id: string) => api.get(`/commercial-proposal/${id}/html`),
};

/** Скачивание PDF КП с корректным именем файла. */
export async function downloadProposalPdf(id: string, proposalNumber: number): Promise<void> {
  try {
    const response = await api.get(`/commercial-proposal/${id}/pdf`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = response.headers["content-disposition"] as string | undefined;
    const match = contentDisposition?.match(/filename="?([^";]+)"?/i);
    const filename = match?.[1] || `KP-${String(proposalNumber).padStart(4, "0")}.pdf`;

    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    message.error("Ошибка при скачивании PDF");
    throw error;
  }
}
